import { createSlice } from "@reduxjs/toolkit";
import UserService from "./../services/UserService";
import { AUTH_TOKEN } from "constants/SiteConstants";
import { fetchBranchBasedOnRole } from "./branches.slice";
import { fetchCategories } from "redux/category.slice";
import { fetchInstructors } from "redux/instructors.slice";

const initialState = {
  isAuth: false,
  branchId: 0,
  userName: "",
  role: "",
  isLoading: false,
  error: "",
  homePage: "",
  permissions: [],
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginRequest(state) {
      state.isLoading = true;
    },
    loginFail(state, action) {
      const { payload } = action;
      state.isAuth = false;
      state.userName = "";
      state.role = "";
      state.homePage = "";
      state.branchId = 0;
      state.isLoading = false;
      state.name = "";
      state.permissions = [];
      state.error = payload;
    },
    loginSuccess(state, action) {
      const { payload } = action;
      state.isAuth = true;
      state.userName = payload.userName;
      state.name = payload.name;
      state.branchId = payload.branchId;
      state.role = payload.role;
      state.homePage = payload.homePage;
      state.isLoading = false;
      state.permissions = payload.permissions;
      state.error = "";
    },
    logoutSuccess(state) {
      state.isAuth = false;
      state.branchId = 0;
      state.userName = "";
      state.name = "";
      state.homePage = "";
      state.role = "";
      state.permissions = [];
      state.isLoading = false;
    },
    userProfileChangedSuccess(state, action) {
      const { userName, name } = action.payload;
      state.name = name;
      state.userName = userName;
    },
  },
});

export const {
  loginRequest,
  loginFail,
  loginSuccess,
  logoutSuccess,
  userProfileChangedSuccess,
} = authSlice.actions;
export default authSlice.reducer;

export const login = (formValues) => async (dispatch) => {
  dispatch(loginRequest());

  const response = await UserService.login(formValues);

  if (response.ok) {
    localStorage.setItem(AUTH_TOKEN, response.data.token);
    dispatch(fetchBranchBasedOnRole(response.data.role));
    dispatch(fetchCategories());
    dispatch(fetchInstructors());
    dispatch(loginSuccess(response.data));
  } else {
    dispatch(loginFail("Login yoki parol noto'g'ri."));
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem(AUTH_TOKEN);
  dispatch(logoutSuccess());
};

export const me = () => async (dispatch) => {
  dispatch(loginRequest());
  const response = await UserService.me();
  if (response.ok) {
    dispatch(fetchBranchBasedOnRole(response.data.role));
    dispatch(fetchCategories());
    dispatch(loginSuccess(response.data));
  } else {
    dispatch(logout());
  }
};

export const authFailCheck = (response) => (dispatch) => {
  const { status } = response;
  if (status === 401 || status === 403) {
    dispatch(logout());
  }
};
